function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "4.877",
  height: "7.91"
}, props), React.createElement("path", {
  d: "M-.001 6.986L3.03 3.955-.001.924.922.001l3.954 3.954L.922 7.909z",
  fill: "#757575"
})));